<template>
  <div class="dashboard">

    <div class="dash-header">
      <div class="dash-time-row">
        <div class="dash-time">{{ time }}</div>
        <div class="dash-date">{{ date }}</div>
      </div>
      <div class="dash-motivation">{{ motivationMessage }}</div>
    </div>

    <div class="dash-menu">
      <p class="menu-label">Quick Actions</p>
      <div class="menu-grid">

        <router-link to="/unconfirmed" class="menu-tile menu-tile--primary">
          <div class="tile-icon-wrap"><i class="ft-plus-circle" style="font-size:x-large !important"></i></div>
          <span>Place New Order</span>
        </router-link>

        <router-link to="/ward" class="menu-tile">
          <div class="tile-icon-wrap"><i class="ft-edit"></i></div>
          <span>Review / Edit Orders</span>
        </router-link>

        <router-link v-if="user.merchant.show_feedback_menu != 'N'" to="/feedback" class="menu-tile">
          <div class="tile-icon-wrap"><i class="ft-message-square"></i></div>
          <span>Feedback</span>
        </router-link>

        <router-link to="/messages" class="menu-tile">
          <div class="tile-icon-wrap"><i class="ft-bell"></i></div>
          <span>Messages</span>
        </router-link>

        <div class="menu-tile" v-if="user.merchant.show_free_issues_menu == 'Y'" v-on:click="freeIssue()">
          <div class="tile-icon-wrap"><i class="ft-package"></i></div>
          <span>Free Issue Orders</span>
        </div>

        <router-link v-if="edit_beds == 'Y'" to="/allbeds" class="menu-tile">
          <div class="tile-icon-wrap"><i class="ft-grid"></i></div>
          <span>Edit / View Beds</span>
        </router-link>

      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'dashboard',
  data: function () {
    return {
      date: moment().format('DD MMMM YYYY'),
      time: moment().format('h:mm'),
      counter: 0,
      syncsRequired: 0,
      online: true,
      user: JSON.parse(window.localStorage.getItem('user')),
      edit_beds: '',
      motivationMessages: [
        'Remember to smile — it makes a difference! 😊',
        'Let\'s get this done — one patient at a time.',
        'Your care matters more than you know.',
        'Great shift ahead — you\'ve got this!',
        'A warm hello goes a long way.',
        'Small acts of kindness change someone\'s day.',
        'Thank you for the work you do every day.',
        'You make the ward a better place.',
        'Stay focused, stay kind, stay amazing.',
        'Every meal you deliver is an act of care.'
      ],
      motivationIndex: Math.floor(Math.random() * 10)

    }
  },
  computed: {
    motivationMessage: function () {
      return this.motivationMessages[this.motivationIndex % this.motivationMessages.length]
    }
  },
  mounted: function () {
    var that = this
    var cart = window.localStorage.getItem('cart') ? JSON.parse(window.localStorage.getItem('cart')) : []
    window.localStorage.setItem('free_issue','N')
    window.localStorage.setItem('ward', '')
    that.user = JSON.parse(window.localStorage.getItem('user'))
    that.edit_beds = that.user.merchant.allow_hostess

    if (cart.length > 0) {
      swal({
        title: 'Warning',
        text: 'You have items in your cart that hasn\'t been checked out.',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Checkout',
            value: 'checkout',
            closeModal: true,
            className: 'btn btn-primary',
            visible: true
          },
          confirm: {
            text: 'DELETE CART',
            value: 'delete',
            closeModal: true,
            className: 'btn btn-danger',
            visible: true
          }
        }
      }).then(function (data) {
        if (data === 'delete') {
          window.localStorage.removeItem('cart')
        } else if (data === 'checkout') {
          that.$router.push('/checkout')
        }
      })
    }

    this.$store.commit('SET_LAYOUT', 'AppLayout')

    setInterval(function () {
      that.time = moment().format('h:mm')
    }, 60000)

    // this.checkIfShouldSync()

    setInterval(function () {
      if (navigator.onLine) {
        that.online = true
      } else {
        that.online = false
      }
    }, 2000)

  },
  methods: {
    freeIssue: function(){
      window.localStorage.setItem('free_issue','Y')
      this.$router.push('/unconfirmed')
    },
    showError: function (message) {
      this.errorMsg = message
    },
     logout: function () {
      localStorage.clear()
      this.$router.push('/login')
    },
     
    checkIfShouldSync: function () {
      // We wanna sync at least daily
      if (!localStorage.getItem('lastSync')) {
        this.sync()
      } else {
        var lastSync = localStorage.getItem('lastSync')
        if (moment().format('YYYY-MM-DD') !== lastSync) {
          this.sync()
        }
      }
    },
    sync: function () {
      if (!navigator.onLine) {
        swal({
          text: 'You need to be online to sync',
          icon: 'info',
          button: 'Ok'
        })
        return false
      }

      window.localStorage.setItem('lastSync', moment().format('YYYY-MM-DD'))

      this.counter = 0 // We use this to hide/show loader
      this.syncsRequired = 0
      $.showLoading()

      this.syncBeds()
    },
    syncBeds: function () {
      var user = JSON.parse(window.localStorage.getItem('user'))
      var merchantId = user.merchant.id

      var typeIds = []
      var that = this

      user.merchant.wards.forEach(function (ward) {
        that.syncsRequired++

        $.ajax({
          url: this.$config.apiUrl +'medicater/beds/' + ward.ward_id,
          type: 'get',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
          },
          complete: function (data) {
            that.counter++
            if (that.counter === that.syncsRequired) {
              that.syncMenus(typeIds)
            }
            if (data && data.responseText) {
              window.localStorage.setItem(this.url, data.responseText)

              if (data.responseJSON.data && data.responseJSON.data.constructor === Array) {
                data.responseJSON.data.forEach(function (bed) {
                  typeIds.push(bed.menu_type_id)
                })
              }
            }
          }
        })

        that.syncsRequired++

        $.ajax({
          url: this.$config.apiUrl +'medicater/beds/' + ward.ward_id + '?date=' + moment().format('YYYY-MM-DD'),
          type: 'get',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
          },
          complete: function (data) {
            that.counter++
            if (that.counter === that.syncsRequired) {
              that.syncMenus(typeIds)
            }
            if (data && data.responseText) {
              window.localStorage.setItem(this.url, data.responseText)

              if (data.responseJSON.data && data.responseJSON.data.constructor === Array) {
                data.responseJSON.data.forEach(function (bed) {
                  typeIds.push(bed.menu_type_id)
                })
              }
            }
          },
          success: function (data) {
            data.data.forEach(function (bed) {
              that.syncsRequired++

              $.ajax({
                url: this.$config.apiUrl +'medicater/calendar/?merchant_id=' + merchantId + '&bed_id=' + bed.bed_id,
                type: 'get',
                beforeSend: function (xhr) {
                  xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
                },
                complete: function (data) {
                  that.counter++
                  if (that.counter === that.syncsRequired) {
                    that.syncMenus(typeIds)
                  }
                  if (data && data.responseText) {
                    window.localStorage.setItem(this.url, data.responseText)
                  }

                  if (data.responseJSON.data && data.responseJSON.data.constructor === Array) {
                    data.responseJSON.data.forEach(function (bed) {
                      typeIds.push(bed.menu_type_id)
                    })
                  }
                }
              })
            })
          }
        })
      }) // End of beds
    },
    syncMenus: function (typeIds) {
      var that = this
      var user = JSON.parse(window.localStorage.getItem('user'))
      var merchantId = user.merchant.id
      this.counter = 0
      this.syncsRequired = 0

      // Let's remove duplicates
      var uniqueNames = []
      $.each(typeIds, function (i, el) {
        if ($.inArray(el, uniqueNames) === -1) uniqueNames.push(el)
      })

      typeIds = uniqueNames

      typeIds.forEach(function (typeId) {
        for (var key in user.merchant.periods) {
          that.syncsRequired++
          // MEAL CATEGORIES
          $.ajax({
            url: this.$config.apiUrl +'canteenapp_merchant/meal_categories?merchant_id=' + merchantId + '&period=' + key + '&date=' + moment().format('YYYY-MM-DD') + '&type_id=' + typeId,
            type: 'get',
            dataType: 'json',
            beforeSend: function (xhr) {
              xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
            },
            complete: function (data) {
              that.counter++
              if (that.counter === that.syncsRequired) {
                $.hideLoading()
              }
              if (data && data.responseText) {
                window.localStorage.setItem(this.url, data.responseText)
              }
            }
          })

          that.syncsRequired++

          $.ajax({
            url: this.$config.apiUrl +'canteenapp_merchant/meal_categories?merchant_id=' + merchantId + '&period=' + key + '&date=' + moment().add(1, 'days').format('YYYY-MM-DD') + '&type_id=' + typeId,
            type: 'get',
            dataType: 'json',
            beforeSend: function (xhr) {
              xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
            },
            complete: function (data) {
              that.counter++
              if (that.counter === that.syncsRequired) {
                $.hideLoading()
              }
              if (data && data.responseText) {
                window.localStorage.setItem(this.url, data.responseText)
              }
            }
          })

          that.syncsRequired++

          $.ajax({
            url: this.$config.apiUrl +'canteenapp_merchant/meal_categories?merchant_id=' + merchantId + '&period=' + key + '&date=' + moment().add(2, 'days').format('YYYY-MM-DD') + '&type_id=' + typeId,
            type: 'get',
            dataType: 'json',
            beforeSend: function (xhr) {
              xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
            },
            complete: function (data) {
              that.counter++
              if (that.counter === that.syncsRequired) {
                $.hideLoading()
              }
              if (data && data.responseText) {
                window.localStorage.setItem(this.url, data.responseText)
              }
            }
          })

          that.syncsRequired++

          $.ajax({
            url: this.$config.apiUrl +'canteenapp_merchant/meal_categories?merchant_id=' + merchantId + '&period=' + key + '&date=' + moment().add(3, 'days').format('YYYY-MM-DD') + '&type_id=' + typeId,
            type: 'get',
            dataType: 'json',
            beforeSend: function (xhr) {
              xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
            },
            complete: function (data) {
              that.counter++
              if (that.counter === that.syncsRequired) {
                $.hideLoading()
              }
              if (data && data.responseText) {
                window.localStorage.setItem(this.url, data.responseText)
              }
            }
          })

          that.syncsRequired++

          // FORMATTED MENU
          $.ajax({
            url: this.$config.apiUrl +'canteenapp_merchant/formatted_menu?type_id=' + typeId + '&merchant_id=' + merchantId + '&period=' + key + '&date=' + moment().format('YYYY-MM-DD'),
            type: 'get',
            dataType: 'json',
            beforeSend: function (xhr) {
              xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
            },
            complete: function (data) {
              that.counter++
              if (that.counter === that.syncsRequired) {
                $.hideLoading()
              }
              if (data && data.responseText) {
                window.localStorage.setItem(this.url, data.responseText)
              }
            }
          })

          that.syncsRequired++

          $.ajax({
            url: this.$config.apiUrl +'canteenapp_merchant/formatted_menu?type_id=' + typeId + '&merchant_id=' + merchantId + '&period=' + key + '&date=' + moment().add(1, 'days').format('YYYY-MM-DD'),
            type: 'get',
            dataType: 'json',
            beforeSend: function (xhr) {
              xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
            },
            complete: function (data) {
              that.counter++
              if (that.counter === that.syncsRequired) {
                $.hideLoading()
              }
              if (data && data.responseText) {
                window.localStorage.setItem(this.url, data.responseText)
              }
            }
          })

          $.ajax({
            url: this.$config.apiUrl +'canteenapp_merchant/formatted_menu?type_id=' + typeId + '&merchant_id=' + merchantId + '&period=' + key + '&date=' + moment().add(2, 'days').format('YYYY-MM-DD'),
            type: 'get',
            dataType: 'json',
            beforeSend: function (xhr) {
              xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
            },
            complete: function (data) {
              that.counter++
              if (that.counter === that.syncsRequired) {
                $.hideLoading()
              }
              if (data && data.responseText) {
                window.localStorage.setItem(this.url, data.responseText)
              }
            }
          })

          that.syncsRequired++

          $.ajax({
            url: this.$config.apiUrl +'canteenapp_merchant/formatted_menu?type_id=' + typeId + '&merchant_id=' + merchantId + '&period=' + key + '&date=' + moment().add(3, 'days').format('YYYY-MM-DD'),
            type: 'get',
            dataType: 'json',
            beforeSend: function (xhr) {
              xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
            },
            complete: function (data) {
              that.counter++
              if (that.counter === that.syncsRequired) {
                $.hideLoading()
              }
              if (data && data.responseText) {
                window.localStorage.setItem(this.url, data.responseText)
              }
            }
          })
        }
      }) // End of typeIds
    }
  }
}


</script>

<style scoped>
.dashboard {
  min-height: 100vh;
 background: #f0f4f800;
     padding-top: 50px;
}

/* ── Header ── */
.dash-header {
  background: linear-gradient(135deg, #0f4c81 0%, #05aceb 100%);
  padding: 28px 24px 32px;
  text-align: center;
  color: #fff;
  border-radius: 28px;
  box-shadow: 0 8px 24px rgba(15, 76, 129, 0.3);
  margin: auto;
}

.dash-time-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.dash-time {
  font-size: 3rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -1px;
}

.dash-date {
  font-size: 0.95rem;
  opacity: 0.75;
}

.dash-motivation {
  margin-top: 14px;
  font-size: 0.88rem;
  font-style: italic;
  color: rgba(255,255,255,0.85);
  background: rgba(255,255,255,0.12);
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 999px;
  padding: 7px 18px;
  display: inline-block;
  line-height: 1.4;
}

/* ── Menu ── */
.dash-menu {
  /* padding: 24px 16px 32px; */
  /* max-width: 600px; */
  margin-top: 2rem !important;
  margin: auto;
}

.menu-label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #17567f;
  margin: 0 4px 14px;
}

.menu-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

@media (min-width: 768px) {
  .menu-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.menu-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: #e85f5e;
  border-radius: 16px;
  padding: 28px 16px 22px;
  text-decoration: none;
  color: #1e293b;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s;
  /* border-top: 4px solid var(--tile-color, #0f4c81); */
}

.menu-tile:hover,
.menu-tile:active {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  text-decoration: none;
  color: #1e293b;
}

.tile-icon-wrap {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: color-mix(in srgb, var(--tile-color, #0f4c81) 12%, transparent);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--tile-color, #fff);
  font-size: 1.4rem;
}

.menu-tile span {
      font-size: 0.92rem;
    font-weight: 900;
    text-align: center;
    color: #fff;
    line-height: 1.3;
}

/* Primary tile — Place New Order — spans full width and stands out */
.menu-tile--primary {
  grid-column: 1 / -1;
  flex-direction: row;
  justify-content: center;
  gap: 14px;
  padding: 22px 20px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  box-shadow: 0 6px 20px rgba(15, 61, 92, 0.35);
}
.menu-tile--primary .tile-icon-wrap {
  width: 44px; height: 44px; border-radius: 12px;
  background: rgba(255,255,255,0.18);
  font-size: 1.3rem;
}
.menu-tile--primary span {
      font-size: x-large;
    font-weight: 500;
    letter-spacing: 0.2px;
}
</style>


